import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/contents';
import { pillClass } from '@/lib/ui';

type ContentCardProps = {
  item: ContentItem;
  featured?: boolean;
};

const ContentCard = ({ item, featured = false }: ContentCardProps) => (
  <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
    <Link to={`/content/${item.id}`} className="relative block w-full overflow-hidden" aria-label={item.title}>
      <div className={`w-full ${featured ? 'h-56 md:h-80' : 'h-44 md:h-48'}`}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 在线看料`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-label font-medium text-foreground-800 backdrop-blur">
        <i className="ri-price-tag-3-line text-xs" />
        {item.categoryName}
      </span>
      <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-label text-background-50">
        {item.duration}
      </span>
      {item.quality === '4K' && (
        <span className="absolute bottom-3 left-3 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-label font-semibold text-foreground-950">
          4K
        </span>
      )}
    </Link>

    <div className="flex flex-1 flex-col p-4 md:p-5">
      <h3 className={`font-heading font-semibold leading-snug text-foreground-950 ${featured ? 'text-lg md:text-xl' : 'text-base'}`}>
        <Link to={`/content/${item.id}`} className="transition-colors hover:text-primary-600">
          {item.title}
        </Link>
      </h3>
      <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
        {item.summary}
      </p>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        {item.tags.slice(0, 2).map((tag) => (
          <span key={tag} className={`${pillClass} bg-secondary-100 text-secondary-900`}>
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-auto flex items-center gap-4 pt-4 text-[11px] font-label text-foreground-500 md:text-xs">
        <span className="inline-flex items-center gap-1">
          <i className="ri-play-circle-line text-sm" />
          {item.views}
        </span>
        <span className="inline-flex items-center gap-1">
          <i className="ri-heart-3-line text-sm" />
          {item.likes}
        </span>
        <span className="ml-auto hidden items-center gap-1 sm:inline-flex">
          <i className="ri-calendar-line text-sm" />
          {item.date}
        </span>
      </div>
    </div>
  </article>
);

export default ContentCard;